import { actionCreator } from 'utils';
import * as ConfigurationTypes from '../types/configurationTypes';

// L O A D   C A R R I E R S   &   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N
export function loadCarriersForConfiguration(key, value) {
    return {
        type: ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION,
        key,
        value,
    };
}

export function loadCarriersForConfigurationRes(key, data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION, 'res'),
        key,
        data,
    };
}

export function loadCarriersForConfigurationErr(key) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION, 'err'),
        key,
    };
}

export function loadPropertyValuesForConfiguration(propertyID) {
    return {
        type: ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION,
        propertyID,
    };
}

export function loadPropertyValuesForConfigurationRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION, 'res'),
        data,
    };
}

export function loadPropertyValuesForConfigurationErr() {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION, 'err'),
    };
}

export function resetCarriersPropertyValuesForConfiguration() {
    return {
        type: ConfigurationTypes.RESET_CARRIERS_PROPERTY_VALUES_FOR_CONFIGURATION,
    }
}
// L O A D   C A R R I E R S   &   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N


// A D D   N E W   C O N F I G U R A T I O N
export function addNewConfiguration(data) {
    return {
        type: ConfigurationTypes.ADD_NEW_CONFIGURATION,
        data,
    };
}

export function addNewConfigurationRes(success) {
    return {
        type: actionCreator(ConfigurationTypes.ADD_NEW_CONFIGURATION, 'res'),
        success,
    };
}

export function addNewConfigurationErr(error) {
    return {
        type: actionCreator(ConfigurationTypes.ADD_NEW_CONFIGURATION, 'err'),
        error,
    };
}
// A D D   N E W   C O N F I G U R A T I O N


// A D D   B U L K   C O N F I G U R A T I O N S
export function addBulkConfigurations(data) {
    return {
        type: ConfigurationTypes.ADD_BULK_CONFIGURATIONS,
        data,
    };
}

export function updateProgressOfBulkConfigurations(configuration) {
    return {
        type: ConfigurationTypes.UPDATE_PROGRESS_OF_BULK_CONFIGURATIONS,
        configuration,
    };
}

export function finishAddingBulkConfigurations() {
    return {
        type: ConfigurationTypes.FINISH_ADDING_BULK_CONFIGURATIONS,
    };
}

export function resetBulkConfigurations() {
    return {
        type: ConfigurationTypes.RESET_BULK_CONFIGURATIONS,
    };
}
// A D D   B U L K   C O N F I G U R A T I O N S


// U P D A T E   T R A N S L A T E   C O N F I G U R A T I O N
export function updateTranslateConfiguration(key) {
    return {
        type: ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION,
        key,
    };
}

export function updateTranslateConfigurationRes(key, loading, success) {
    return {
        type: actionCreator(ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION, 'res'),
        key,
        loading,
        success,
    };
}

export function updateTranslateConfigurationErr(key) {
    return {
        type: actionCreator(ConfigurationTypes.UPDATE_TRANSLATE_CONFIGURATION, 'err'),
        key,
    };
}
// U P D A T E   T R A N S L A T E   C O N F I G U R A T I O N


// L O A D   E D I T A B L E   C O N F I G U R A T I O N
export function loadEditableConfiguration(id) {
    return {
        type: ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION,
        id,
    };
}

export function loadEditableConfigurationRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION, 'res'),
        data,
    };
}

export function loadEditableConfigurationErr(error) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_EDITABLE_CONFIGURATION, 'err'),
        error,
    };
}
// L O A D   E D I T A B L E   C O N F I G U R A T I O N


// E D I T   C O N F I G U R A T I O N
export function editConfiguration(data) {
    return {
        type: ConfigurationTypes.EDIT_CONFIGURATION,
        data,
    };
}

export function editConfigurationRes(success) {
    return {
        type: actionCreator(ConfigurationTypes.EDIT_CONFIGURATION, 'res'),
        success,
    };
}

export function editConfigurationErr(error) {
    return {
        type: actionCreator(ConfigurationTypes.EDIT_CONFIGURATION, 'err'),
        error,
    };
}
// E D I T   C O N F I G U R A T I O N


// L O A D   C O N F I G U R A T I O N S
export function loadConfigurations() {
    return {
        type: ConfigurationTypes.LOAD_CONFIGURATIONS,
    };
}

export function loadConfigurationsRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CONFIGURATIONS, 'res'),
        data,
    };
}

export function loadConfigurationsErr() {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CONFIGURATIONS, 'err'),
    };
}
// L O A D   C O N F I G U R A T I O N S


// S E T   C O N F I G U R A T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T
export function setConfigurationFilters(key, value) {
    return {
        type: ConfigurationTypes.SET_CONFIGURATION_FILTER,
        key,
        value,
    };
}

export function setConfigurationFiltersRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.SET_CONFIGURATION_FILTER, 'res'),
        data,
    };
}

export function setConfigurationPagination(key, pagination) {
    return {
        type: ConfigurationTypes.SET_CONFIGURATION_PAGINATION,
        key,
        pagination,
    };
}

export function setConfigurationSort(sort) {
    return {
        type: ConfigurationTypes.SET_CONFIGURATION_SORT,
        sort,
    };
}

export function resetConfigurationFilters() {
    return {
        type: ConfigurationTypes.RESET_CONFIGURATION_FILTERS,
    };
}
// S E T   C O N F I G U R A T I O N   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T


// L O A D   C A R R I E R S   F O R   C O N F I G U R A T I O N
export function loadCarriersForConfigurationFilter(value) {
    return {
        type: ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER,
        value,
    };
}

export function loadCarriersForConfigurationFilterRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER, 'res'),
        data,
    };
}

export function loadCarriersForConfigurationFilterErr() {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_CARRIERS_FOR_CONFIGURATION_FILTER, 'err'),
    };
}
// L O A D   C A R R I E R S   F O R   C O N F I G U R A T I O N


// L O A D   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N   F I L T E R
export function loadPropertyValuesForConfigurationFilter(value) {
    return {
        type: ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER,
        value,
    };
}

export function loadPropertyValuesForConfigurationFilterRes(data) {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER, 'res'),
        data,
    };
}

export function loadPropertyValuesForConfigurationFilterErr() {
    return {
        type: actionCreator(ConfigurationTypes.LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER, 'err'),
    };
}
// L O A D   P R O P E R T Y   V A L U E S   F O R   C O N F I G U R A T I O N   F I L T E R


// T O G G L E   C O N F I G U R A T I O N   S T A T U S
export function toggleConfigurationStatus(id, status) {
    return {
        type: ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS,
        id,
        status,
    };
}

export function toggleConfigurationStatusRes() {
    return {
        type: actionCreator(ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS, 'res'),
    };
}

export function toggleConfigurationStatusErr() {
    return {
        type: actionCreator(ConfigurationTypes.TOGGLE_CONFIGURATION_STATUS, 'err'),
    };
}
// T O G G L E   C O N F I G U R A T I O N   S T A T U S


// S E T   C H E C K E D   C O N F I G U R A T I O N
export function setCheckedConfigurations(ids) {
    return {
        type: ConfigurationTypes.SET_CHECKED_CONFIGURATIONS,
        ids,
    };
}
// S E T   C H E C K E D   C O N F I G U R A T I O N


// B U L K   C H E C K E D   C O N F I G U R A T I O N S
export function bulkCheckedConfigurations(ids, bulk) {
    return {
        type: ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS,
        bulk,
        ids,
    };
}

export function bulkCheckedConfigurationsRes() {
    return {
        type: actionCreator(ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS, 'res'),
        ids: [],
    };
}

export function bulkCheckedConfigurationsErr() {
    return {
        type: actionCreator(ConfigurationTypes.BULK_CHECKED_CONFIGURATIONS, 'err'),
    };
}
// B U L K   C H E C K E D   C O N F I G U R A T I O N S
